/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import * as web3Service from '../blockchain/web3.service'

export const useNFTPrice = (props) => {

  const { category } = props
  const [nftPrice, setNftPrice] = useState(0.0)
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (category) {
      fetchNFTPriceByCategory()
    }
  }, [category])

  const fetchNFTPriceByCategory = async () => {
    try {
      setLoading(true)
      const nftPriceResponse = await web3Service.getNFTPriceByCategoryInBUSD(category)
      setNftPrice(nftPriceResponse)
    } catch (error) {
      setNftPrice(0.00)
      console.error('error while fetching nft price from hook ', error)
    } finally {
      setLoading(false)
    }
  }
  return { nftPrice, isLoading }
}

export default useNFTPrice

